import { render, staticRenderFns } from "./ApparatusDetails.vue?vue&type=template&id=78893259&scoped=true"
import script from "./ApparatusDetails.vue?vue&type=script&lang=js"
export * from "./ApparatusDetails.vue?vue&type=script&lang=js"
import style0 from "./ApparatusDetails.vue?vue&type=style&index=0&id=78893259&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78893259",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78893259')) {
      api.createRecord('78893259', component.options)
    } else {
      api.reload('78893259', component.options)
    }
    module.hot.accept("./ApparatusDetails.vue?vue&type=template&id=78893259&scoped=true", function () {
      api.rerender('78893259', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ApparatusDetails.vue"
export default component.exports